import React from 'react';
import { SenderIDListPage } from './list';

export const SenderIDModule = () => {
  return (
    <>
      <SenderIDListPage />
    </>
  );
};
